import { z } from 'zod'

export const US_STATE_OPTIONS = [
	{ value: 'AL', label: 'Alabama' },
	{ value: 'AK', label: 'Alaska' },
	{ value: 'AZ', label: 'Arizona' },
	{ value: 'AR', label: 'Arkansas' },
	{ value: 'CA', label: 'California' },
	{ value: 'CO', label: 'Colorado' },
	{ value: 'CT', label: 'Connecticut' },
	{ value: 'DE', label: 'Delaware' },
	{ value: 'DC', label: 'District of Columbia' },
	{ value: 'FL', label: 'Florida' },
	{ value: 'GA', label: 'Georgia' },
	{ value: 'HI', label: 'Hawaii' },
	{ value: 'ID', label: 'Idaho' },
	{ value: 'IL', label: 'Illinois' },
	{ value: 'IN', label: 'Indiana' },
	{ value: 'IA', label: 'Iowa' },
	{ value: 'KS', label: 'Kansas' },
	{ value: 'KY', label: 'Kentucky' },
	{ value: 'LA', label: 'Louisiana' },
	{ value: 'ME', label: 'Maine' },
	{ value: 'MD', label: 'Maryland' },
	{ value: 'MA', label: 'Massachusetts' },
	{ value: 'MI', label: 'Michigan' },
	{ value: 'MN', label: 'Minnesota' },
	{ value: 'MS', label: 'Mississippi' },
	{ value: 'MO', label: 'Missouri' },
	{ value: 'MT', label: 'Montana' },
	{ value: 'NE', label: 'Nebraska' },
	{ value: 'NV', label: 'Nevada' },
	{ value: 'NH', label: 'New Hampshire' },
	{ value: 'NJ', label: 'New Jersey' },
	{ value: 'NM', label: 'New Mexico' },
	{ value: 'NY', label: 'New York' },
	{ value: 'NC', label: 'North Carolina' },
	{ value: 'ND', label: 'North Dakota' },
	{ value: 'OH', label: 'Ohio' },
	{ value: 'OK', label: 'Oklahoma' },
	{ value: 'OR', label: 'Oregon' },
	{ value: 'PA', label: 'Pennsylvania' },
	{ value: 'RI', label: 'Rhode Island' },
	{ value: 'SC', label: 'South Carolina' },
	{ value: 'SD', label: 'South Dakota' },
	{ value: 'TN', label: 'Tennessee' },
	{ value: 'TX', label: 'Texas' },
	{ value: 'UT', label: 'Utah' },
	{ value: 'VT', label: 'Vermont' },
	{ value: 'VA', label: 'Virginia' },
	{ value: 'WA', label: 'Washington' },
	{ value: 'WV', label: 'West Virginia' },
	{ value: 'WI', label: 'Wisconsin' },
	{ value: 'WY', label: 'Wyoming' },
] as const

export const COUNTRY_OPTIONS = [
	{ value: 'US', label: 'United States' },
	{ value: 'CA', label: 'Canada' },
	{ value: 'MX', label: 'Mexico' },
	{ value: 'AR', label: 'Argentina' },
	{ value: 'AU', label: 'Australia' },
	{ value: 'BE', label: 'Belgium' },
	{ value: 'BR', label: 'Brazil' },
	{ value: 'CL', label: 'Chile' },
	{ value: 'CN', label: 'China' },
	{ value: 'CO', label: 'Colombia' },
	{ value: 'DK', label: 'Denmark' },
	{ value: 'FI', label: 'Finland' },
	{ value: 'FR', label: 'France' },
	{ value: 'DE', label: 'Germany' },
	{ value: 'HK', label: 'Hong Kong' },
	{ value: 'IN', label: 'India' },
	{ value: 'IE', label: 'Ireland' },
	{ value: 'IL', label: 'Israel' },
	{ value: 'IT', label: 'Italy' },
	{ value: 'JP', label: 'Japan' },
	{ value: 'KR', label: 'South Korea' },
	{ value: 'MY', label: 'Malaysia' },
	{ value: 'NL', label: 'Netherlands' },
	{ value: 'NZ', label: 'New Zealand' },
	{ value: 'NO', label: 'Norway' },
	{ value: 'PH', label: 'Philippines' },
	{ value: 'PL', label: 'Poland' },
	{ value: 'PT', label: 'Portugal' },
	{ value: 'SA', label: 'Saudi Arabia' },
	{ value: 'SG', label: 'Singapore' },
	{ value: 'ZA', label: 'South Africa' },
	{ value: 'ES', label: 'Spain' },
	{ value: 'SE', label: 'Sweden' },
	{ value: 'CH', label: 'Switzerland' },
	{ value: 'TW', label: 'Taiwan' },
	{ value: 'TH', label: 'Thailand' },
	{ value: 'TR', label: 'Turkey' },
	{ value: 'AE', label: 'United Arab Emirates' },
	{ value: 'GB', label: 'United Kingdom' },
	{ value: 'VN', label: 'Vietnam' },
	{ value: 'OTHER', label: 'Other' },
] as const

export const AddressSchema = z.object({
	street: z
		.string({
			required_error: 'Enter the street address.',
		})
		.min(1, 'Enter the street address.'),
	street2: z.string().optional(),
	city: z
		.string({
			required_error: 'Enter the city.',
		})
		.min(1, 'Enter the city.'),
	state: z
		.string({
			required_error: 'Enter the state, province, or region.',
		})
		.min(1, 'Enter the state, province, or region.'),
	postalCode: z
		.string({
			required_error: 'Enter the postal code.',
		})
		.min(1, 'Enter the postal code.'),
	country: z.enum(
		COUNTRY_OPTIONS.map((option) => option.value) as [
			(typeof COUNTRY_OPTIONS)[number]['value'],
			...string[],
		],
	),
})

export type AddressFormValues = z.infer<typeof AddressSchema>

export function createEmptyAddress(): AddressFormValues {
	return {
		street: '',
		street2: '',
		city: '',
		state: '',
		postalCode: '',
		country: '',
	}
}
